module.exports = __webpack_public_path__ + "static/media/weekend.dba94339.webp";